export default {
    gapSmall: '4px 8px',
    gapMedium: '8px 12px',
    gapLarge: '12px 16px'
};
